"use client";

import * as React from "react";
import { cn } from "../../lib/utils";

export interface EarningsPeriodCardProps {
  date: string;
  range: string;
  amount: string;
  badges?: string[];
  className?: string;
  showDate?: boolean;
  isGrayedOut?: boolean;
  footer?: React.ReactNode;
}

export function EarningsPeriodCard({ 
  date, 
  range, 
  amount, 
  badges = [], 
  className, 
  showDate = true,
  isGrayedOut = false,
  footer
}: EarningsPeriodCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border px-4 py-3 shadow-[0_2px_0_0_rgba(0,0,0,0.12)]",
        isGrayedOut ? "border-[#F2F4F7] bg-[#F9FAFB]" : "border-[#98A2B3] bg-white",
        className
      )}
    >
      {showDate && <p className="text-xs text-[#98A2B3]">{date}</p>}
      <div className={cn("flex items-center justify-between", showDate && "mt-2")}>
        <p className="text-sm font-semibold text-[#344054]">{range}</p>
        <p className="text-2xl font-bold text-[#344054]">{amount}</p>
      </div>
      {badges.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {badges.map((badge) => (
            <span
              key={badge}
              className="rounded border border-[#D1D1D6] bg-[#FBFBFB] px-2 py-0.5 text-[10px] font-medium text-[#667085]"
            >
              {badge}
            </span>
          ))}
        </div>
      )}
      {footer && (
        <div className="mt-3 border-t border-[#EAECF0] pt-2 text-xs text-[#667085]">
          {footer}
        </div>
      )}
    </div>
  );
}
